import styled from 'styled-components';

export const Container = styled.div`
  padding: ${props => props.theme.spacing(8, 0)};
  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(8)};
    max-width: 936px;
  }
`;

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${props => props.theme.spacing(12, 0, 4, 0)};

  @media ${props => props.theme.tablet} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ItemContainer = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.spacing(8)};
  display: flex;
  flex-direction: row;

  @media ${props => props.theme.tablet} {
    width: ${props => props.theme.spacing(62)};
    flex-direction: column;
    align-items: center;
  }
`;

export const Icon = styled.img`
  height: ${props => props.theme.spacing(16)};
  width: ${props => props.theme.spacing(16)};

  @media ${props => props.theme.tablet} {
    height: ${props => props.theme.spacing(24)};
    width: ${props => props.theme.spacing(24)};
  }
`;

export const ItemTextContainer = styled.div`
  margin-left: ${props => props.theme.spacing(6)};

  @media ${props => props.theme.tablet} {
    margin: 0;
  }
`;

export const ItemHeading = styled.h4`
  ${props => props.theme.typography.subheading1}
  text-transform: uppercase;
  @media ${props => props.theme.tablet} {
    margin-top: ${props => props.theme.spacing(6)};
    text-align: center;
    min-height: 56px;
  }
`;

export const ItemText = styled.p`
  ${props => props.theme.typography.body}
  margin-top: ${props => props.theme.spacing(1)};

  @media ${props => props.theme.tablet} {
    margin-top: ${props => props.theme.spacing(2)};
    text-align: center;
  }
`;

export const ButtonContainer = styled.div`
  max-width: ${props => props.theme.spacing(84)};
  margin: 0 auto;
`;

export const Disclaimer = styled.div`
  ${props => props.theme.typography.label};
  margin-top: ${props => props.theme.spacing(10)};
  text-align: center;
  color: ${props => props.theme.colors.text.tertiary};
`;
